/** Delay execution */
export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

/** Parse URL query parameters */
export function getQuerys(url: string): Record<string, string> {
  const querys: Record<string, string> = {}
  const search = url.split('?')[1]
  if (!search) return querys
  const pairs = search.split('&')
  for (const pair of pairs) {
    const [key, value] = pair.split('=')
    if (key) querys[key] = decodeURIComponent(value || '')
  }
  return querys
}

/** Fix iOS input blur scrolling issue */
export function fixIosInputBlur(): void {
  document.body.addEventListener('focusout', () => {
    setTimeout(() => {
      const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
      window.scrollTo(0, Math.max(scrollHeight - 1, 0))
    }, 100)
  })
}

/** Get token icon URL */
export function getCoinIcon(contract: string, symbol: string): string {
  return `https://cdn.jsdelivr.net/gh/metahubwallet/eos-tokens@master/logos/eos/${contract}-${symbol.toLowerCase()}.png`
}

/** Parse quantity string "1.0000 EOS" -> { amount, symbol } */
export function parseQuantity(quantity: string): { amount: string; symbol: string } {
  const parts = quantity.trim().split(' ')
  return { amount: parts[0], symbol: parts[1] || '' }
}

/** Format countdown seconds to readable string */
export function formatCountdown(seconds: number): string {
  const d = Math.floor(seconds / 86400)
  const h = Math.floor((seconds % 86400) / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  const s = seconds % 60
  if (d > 0) return `${d}d ${h}h ${m}m`
  if (h > 0) return `${h}h ${m}m ${s}s`
  return `${m}m ${s}s`
}
